import { Box, Text } from "@chakra-ui/react"
import { PublicationBlockVideoPublic } from "../../client"
import ReactPlayer from "react-player"


const VideoBlock = ({ data }: { data: PublicationBlockVideoPublic }) => {

    return (
        <Box my={10} boxShadow={"rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"} borderRadius="md">
            {ReactPlayer.canPlay && ReactPlayer.canPlay(data.url) &&
                <ReactPlayer 
                    src={data.url} 
                    controls
                    style={{ 
                        width: "100%", 
                        height: "auto", 
                        aspectRatio: "16/9",
                        borderTopLeftRadius: "0.375rem",
                        borderTopRightRadius: "0.375rem",
                        overflow: "hidden",
                    }}  
                />
            }

            {data.description &&
                <Text py={4} pl={4}>{data.description}</Text>
            }
        </Box>
    )
}

export default VideoBlock